import { PayloadAction } from '@reduxjs/toolkit';
import { WritableDraft } from 'immer';

import { QuoteBuilderStateType } from '../../types/state';

export function marketCodeSelected(
  state: WritableDraft<QuoteBuilderStateType>,
  action: PayloadAction<string>,
) {
  state.marketCode = action.payload;
}
